import "./addDocument.scss";
import {useEffect, useState} from "react";
import { toast } from "react-toastify";
import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { formatJalaliDateFa } from "../../utils/formatJalaliDateFa";
import { FaToEnDigits } from "../../utils/faToEnDigits";
import { useFormFields } from "../../hooks/useFormFields";
import { AddDocument } from "../../services/documentService";
import Button from "../button/button";
import TextInput from "../textInput/textInput";
import IconButton from "../iconButton/iconButton"
import AddDocumentIcon from "../../assets/images/archivePassive.svg";
import EnterIcon from "../../assets/images/enter.svg";
import CloseIcon from "../../assets/images/closeCancel.svg";

export default function AddDocumentComponent({currentDate, afterAddDocument, onClose}) {
  const [file, setFile] = useState(null);
  const [date, setDate] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const allowed = ["application/pdf", "image/jpeg", "image/png", "image/webp"];
  
  useEffect(() => {
    setDate(FaToEnDigits(currentDate.format("YYYYMMDD")));
  }, [currentDate]);

  const onPickFile = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;

    if (!allowed.includes(f.type)) {
      toast.error("نوع فایل مجاز نیست (PDF/JPG/PNG/WEBP)", { toastId: "error" });

      e.target.value = "";
      return;
    }

    const max = 25 * 1024 * 1024;
    if (f.size > max) {
      toast.error("حجم فایل نباید بیشتر از 25MB باشد", { toastId: "error" });
      e.target.value = "";
      return;
    }
    setFile(f);
  };

  const addDocument = async () => {
    if (title !== "" && description !== "" && file != null) {
      setLoading(true);
      setProgress(0);
      try {
        await AddDocument({date, title, description, file, onProgress: setProgress});
        setFile(null);
        setTitle("");
        setDescription("");
        setProgress(0);
        afterAddDocument()
      } catch (err) {
          if (err.document) {
            toast.error(`این سند قبلا در تاریخ ${formatJalaliDateFa(err.document.date)} ثبت شده است`, { toastId: "error" });
          } else {
            toast.error(err.error, { toastId: "error" });
          }
      } finally {
        setLoading(false);
      }
    } else {
       toast.error("وارد کردن تمامی موارد الزامی است", { toastId: "error" });
    }
  };

  return (
    <div className="addDocument form actionWrapper">
      <IconButton icon={CloseIcon} tooltip="بیخیال" onClick={onClose} className="closeIcon" />
      <img src={AddDocumentIcon} alt="icon" className="notMobile"/>
      <div className="documentRows">
        <div className="documentRow">
          <TextInput
            label={"عنوان"}
            val={title}
            onChange={(e) => setTitle(e)}  
          />
        </div>
        <div className="documentRow">
          <TextInput
            label={"توضیحات"}
            val={description}
            onChange={(e) => setDescription(e)}  
          />
        </div>
        <div className="documentRow">
          <label>انتخاب فایل:</label>
           <input type="file" accept=".pdf,image/*" onChange={onPickFile} />
        </div>
      </div>
      {loading ?(
        <div>
          <div>Uploading: {progress}%</div>
          <progress value={progress} max="100" style={{ width: "100%" }} />
        </div>
      ) : (
        <>
          <Button text="ثبت" loading={loading}  onClick={() => addDocument()} className="center notDesktop" width={100} />
          <IconButton icon={EnterIcon} loading={loading} tooltip="ثبت" onClick={() => addDocument()}  className="notMobile"/>
        </>
      ) }
      
    </div>
  );
}
